/* eslint-disable */
import { ORDER_ID_UNSELECTED } from '../Orders.types';

/**
 * Unselect the currently selected order id
 * @returns {ActionCreator<FromPayload<Array<string>, ActionMeta, ORDER_DETAILS_UNSELECTED>>} The created `Action`
 */
const orderIdUnselected = () => ({ fromPayload }) => {
  return fromPayload(null, null, ORDER_ID_UNSELECTED);
};

export default orderIdUnselected;
